import { createStore } from '@stencil/store';

import { MinimalCertificateDisplayType } from '../interfaces/interface.minimal-certificate-offer';

const initialState = {
  amount: 0,
  offerId: '',
  expirationDate: '',
  isExpired: false,
  dealerId: 0,
  status: '',
  isEligible: true,
  isFurtherReviewNeeded: false,
  isInspectionNeeded: false,
  isOfferUnderReview: false,
  isIneligibleOffer: false,
  offerCode: '',
  ineligibleReasons: '',
  isKelleyBuysYourCar: false,
  displayType: MinimalCertificateDisplayType.NotAvailable,
  vehicleInfo: {},
  contactInfo: {},
};

type MinimalCertificateState = typeof initialState;
const { on, onChange, state, reset } = createStore(initialState);
export { initialState, on, onChange, state, reset, MinimalCertificateState };
